/* IV-ICE — theme.js */
document.addEventListener('DOMContentLoaded', function () {

  // Sync cart badge on every page load
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart) {
      var badge = document.getElementById('cart-count');
      if (!badge) return;
      badge.textContent = cart.item_count;
      if (cart.item_count > 0) { badge.classList.remove('cart-badge--hidden'); }
      else { badge.classList.add('cart-badge--hidden'); }
    });

  // Header search
  var searchInput = document.getElementById('header-search-input');
  if (searchInput) {
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && this.value.trim()) {
        window.location.href = '/search?type=product&q=' + encodeURIComponent(this.value.trim());
      }
    });
  }

});
